import {Component} from '@angular/core';
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {PopulationUsageRole} from "@domain/admin/entreprise/population/population-usage-role";

/**
 * Composant d'affichage de la page affichant la liste de l'usage des rôles
 *
 * @author Lionel Gimenez
 * @date 02/06/2025
 */
@Component({
    host: {'data-test-id': 'population-usage-role'},
    templateUrl: './population-usage-role.component.html'
})
export class PopulationUsageRoleComponent extends ListViewItem<PopulationUsageRole> {
}